import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ResetPasswordWidget as mainModule } from './main';
import * as Config from './config';

declare var require: any;
require('../sass/pdc-widget-reset-password.sass');

export class ResetPasswordWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;

    public static load() {
        const def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                const module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-reset-password'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ResetPasswordWidget);
